"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_redux_1 = require("react-redux");
const react_i18next_1 = require("react-i18next");
function default_1() {
    const paytype = (0, react_redux_1.useSelector)((state) => state.roomData.paytype);
    const isLoginRequired = paytype === 'login_required';
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ css: { marginBottom: '10px', backgroundColor: 'white' } }, { children: !isLoginRequired && ((0, jsx_runtime_1.jsxs)("div", Object.assign({ css: {
                display: 'flex',
                alignItems: 'center',
                columnGap: '8px',
                padding: '14px 16px',
                borderBottom: '1px solid rgba(0, 0, 0, 0.05)',
            } }, { children: [(0, jsx_runtime_1.jsx)("img", { src: `${process.env.CDN_URL}/assets/svgs/adult_only.svg`, css: { width: '24px', height: '24px', padding: '3px' } }), (0, jsx_runtime_1.jsxs)("div", Object.assign({ css: {
                        display: 'flex',
                        columnGap: '4px',
                        lineHeight: '22px',
                        fontSize: '15px',
                        color: 'rgba(0, 0, 0, 0.8)',
                    } }, { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ css: { fontWeight: 'bold' } }, { children: t('성인만') })), t('신청 가능')] }))] }))) })));
}
exports.default = default_1;
